// extracted by mini-css-extract-plugin
module.exports = {"fp-products-slider":"FourPictures_fp-products-slider__YGB2X","load":"FourPictures_load__kIei3"};